// extracted by mini-css-extract-plugin
export default {"heading":"Vv-z","corrected":"Wv-z","redirectVerbiageContainer":"Xv-z","redirectVerbiageText":"Yv-z"};